import styled from 'styled-components';
import { FmToggleButton } from '../FmToggleButton/FmToggleButton';

export const StyledFmButton = styled(FmToggleButton)(({ theme }) => ({
  borderRadius: '999px 0 0 999px',
  border: `1px solid ${theme.colors.neutral[300]}`,
  background: theme.colors.white,

  '&:not(.disabled):hover': {
    borderColor: theme.colors.neutral[300],
  },

  '&:not(.disabled):focus': {
    background: theme.colors.white,
  },
}));

export const Trigger = styled(FmToggleButton)(({ theme }) => ({
  borderRadius: '0 999px 999px 0',
  height: 34,
  padding: '0 12px',
  marginLeft: -1,
  border: `1px solid ${theme.colors.neutral[300]}`,
  background: theme.colors.white,
  textOverflow: 'unset',
  flexShrink: 0,

  '&:not(.disabled):focus': {
    background: theme.colors.white,
  },

  '&&:hover': {
    color: theme.colors.black,
    background: theme.colors.neutral['200'],
  },
}));
